export default function AboutPage() {
  const orgLd = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '皮皮漫画网',
    description: '专业的韩漫在线阅读平台，提供免费韩国漫画下拉式阅读和全集漫画大全。',
    url: 'https://mousehole.cn',
    contactPoint: {
      '@type': 'ContactPoint',
      contactType: 'customer service',
      email: 'support@mousehole.cn',
    },
  };

  const faqLd = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      {
        '@type': 'Question',
        name: '皮皮漫画网的漫画都是免费的吗？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '是的，皮皮漫画网所有韩漫资源均免费提供在线阅读，无需任何付费即可畅享全集漫画大全。',
        },
      },
      {
        '@type': 'Question',
        name: '如何在皮皮漫画网找到想看的漫画？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '您可以通过首页的分类导航、搜索功能，或直接浏览漫画分类页面来查找感兴趣的漫画。我们提供按类别、评分、更新时间等多种筛选方式。',
        },
      },
      {
        '@type': 'Question',
        name: '皮皮漫画网的漫画更新频率如何？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '皮皮漫画网每日更新200+话漫画内容，热门韩国漫画资源第一时间同步，确保您不错过任何精彩章节。',
        },
      },
    ],
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(orgLd)}</script>
      <script type="application/ld+json">{JSON.stringify(faqLd)}</script>

      <main>
        {/* Header */}
        <section className="relative w-full h-[280px] md:h-[360px] overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=A%20warm%20and%20elegant%20abstract%20Korean%20art%20background%20with%20soft%20ink%20wash%20brushstrokes%2C%20crimson%20and%20golden%20accents%2C%20literary%20atmosphere%2C%20traditional%20meets%20modern%20aesthetic%2C%20gentle%20texture%2C%20artistic%20style&width=1920&height=500&seq=about-hero-bg&orientation=landscape"
            alt=""
            className="absolute inset-0 w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/20 to-black/50"></div>
          <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-4">
            <h1 className="font-heading font-bold text-3xl md:text-4xl text-background-50 mb-3">
              关于<strong>皮皮漫画网</strong>
            </h1>
            <p className="text-sm md:text-base text-background-100/80 max-w-xl">
              致力于为漫画爱好者提供最优质的韩漫在线阅读体验
            </p>
          </div>
        </section>

        {/* Brand Introduction */}
        <section className="max-w-4xl mx-auto px-4 md:px-6 py-14">
          <div className="text-center mb-10">
            <h2 className="font-heading font-bold text-2xl text-foreground-950 mb-4">品牌介绍</h2>
            <div className="w-12 h-1 rounded-full bg-primary-500 mx-auto mb-6"></div>
          </div>

          <div className="space-y-6">
            <div className="p-6 rounded-lg bg-background-50 border border-background-200/70">
              <h3 className="font-heading font-semibold text-lg text-foreground-950 mb-3">关于皮皮漫画网</h3>
              <p className="text-sm text-foreground-600 leading-relaxed mb-3">
                皮皮漫画网成立于2020年，是国内领先的韩漫在线阅读平台。我们专注于为用户提供免费韩国漫画下拉式阅读服务，拥有海量全集漫画大全资源。平台上线以来，已累计服务超过850万漫画爱好者，每日更新超过200话优质漫画内容。
              </p>
              <p className="text-sm text-foreground-600 leading-relaxed">
                我们深知漫画爱好者对于阅读体验的要求，因此皮皮漫画网采用专为移动端优化的下拉式阅读模式，让用户可以流畅地沉浸在漫画世界中。无论您喜欢恋爱言情、奇幻冒险、热血动作还是悬疑推理，皮皮漫画网都能满足您的阅读需求。
              </p>
            </div>

            <div className="p-6 rounded-lg bg-background-50 border border-background-200/70">
              <h3 className="font-heading font-semibold text-lg text-foreground-950 mb-3">我们的使命</h3>
              <p className="text-sm text-foreground-600 leading-relaxed mb-3">
                皮皮漫画网的使命是让每一位漫画爱好者都能轻松享受高质量的韩漫阅读体验。我们相信，优秀的漫画作品应该被更多人看到，而不是被付费墙所阻挡。
              </p>
              <p className="text-sm text-foreground-600 leading-relaxed">
                我们持续扩充漫画资源库，目前已收录超过12,580部韩漫作品，涵盖十个主要分类。从经典完结作品到热门连载新作，皮皮漫画网致力于成为您最信赖的漫画阅读伙伴。
              </p>
            </div>

            <div className="p-6 rounded-lg bg-background-50 border border-background-200/70">
              <h3 className="font-heading font-semibold text-lg text-foreground-950 mb-3">核心特色</h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                {[
                  { icon: 'ri-smartphone-line', title: '下拉式阅读', desc: '专为手机优化的流畅阅读体验，上下滑动即可畅读漫画。' },
                  { icon: 'ri-coin-line', title: '完全免费', desc: '无需任何费用，所有漫画资源免费开放阅读。' },
                  { icon: 'ri-database-2-line', title: '海量资源', desc: '收录12,580+部韩漫，十大分类全覆盖。' },
                  { icon: 'ri-time-line', title: '极速更新', desc: '每日200+话更新，热门新番第一时间同步。' },
                  { icon: 'ri-hd-line', title: '高清画质', desc: '高品质画面呈现，细节清晰不失真。' },
                  { icon: 'ri-shield-check-line', title: '安全可靠', desc: '正规内容来源，保护用户隐私和信息安全。' },
                ].map((item) => (
                  <div key={item.title} className="flex gap-3 items-start">
                    <div className="w-10 h-10 flex-shrink-0 flex items-center justify-center rounded-full bg-primary-100">
                      <i className={`${item.icon} text-primary-500`}></i>
                    </div>
                    <div>
                      <h4 className="font-medium text-sm text-foreground-950 mb-1">{item.title}</h4>
                      <p className="text-xs text-foreground-600 leading-relaxed">{item.desc}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* Reputation Section */}
        <section className="bg-background-100 py-14">
          <div className="max-w-4xl mx-auto px-4 md:px-6">
            <div className="text-center mb-10">
              <h2 className="font-heading font-bold text-2xl text-foreground-950 mb-4">信誉与口碑</h2>
              <div className="w-12 h-1 rounded-full bg-accent-500 mx-auto mb-6"></div>
              <p className="text-sm text-foreground-600 max-w-2xl mx-auto">
                皮皮漫画网自成立以来，始终坚持用户至上的原则，赢得了广大漫画爱好者的信任与好评。
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-10">
              <div className="p-6 rounded-lg bg-background-50 border border-background-200/70 text-center">
                <div className="text-4xl font-heading font-bold text-primary-500 mb-2">98.6%</div>
                <div className="text-sm text-foreground-600">用户好评率</div>
              </div>
              <div className="p-6 rounded-lg bg-background-50 border border-background-200/70 text-center">
                <div className="text-4xl font-heading font-bold text-accent-500 mb-2">850万+</div>
                <div className="text-sm text-foreground-600">累计服务用户</div>
              </div>
              <div className="p-6 rounded-lg bg-background-50 border border-background-200/70 text-center">
                <div className="text-4xl font-heading font-bold text-primary-500 mb-2">5年+</div>
                <div className="text-sm text-foreground-600">持续运营时间</div>
              </div>
              <div className="p-6 rounded-lg bg-background-50 border border-background-200/70 text-center">
                <div className="text-4xl font-heading font-bold text-accent-500 mb-2">200+</div>
                <div className="text-sm text-foreground-600">每日更新话数</div>
              </div>
            </div>

            <div className="space-y-4">
              {[
                { name: '小漫画迷', text: '一直在皮皮漫画网追更，资源很全，更新也快，最重要的是完全免费！推荐给所有喜欢韩漫的朋友。', rating: 5 },
                { name: '追漫达人', text: '下拉式阅读体验真的很好，手机上看起来很舒服。漫画分类也很清晰，找漫画很方便。', rating: 5 },
                { name: '日漫韩漫通吃', text: '用了很多漫画网站，皮皮漫画网是我最常用的。画质清晰，章节齐全，强烈推荐！', rating: 5 },
              ].map((review) => (
                <div key={review.name} className="p-5 rounded-lg bg-background-50 border border-background-200/70">
                  <div className="flex items-center gap-2 mb-2">
                    <div className="w-8 h-8 rounded-full bg-primary-100 flex items-center justify-center">
                      <i className="ri-user-line text-primary-500 text-xs"></i>
                    </div>
                    <span className="font-medium text-sm text-foreground-950">{review.name}</span>
                    <div className="flex gap-0.5 ml-auto">
                      {Array.from({ length: review.rating }).map((_, i) => (
                        <i key={i} className="ri-star-fill text-accent-500 text-xs"></i>
                      ))}
                    </div>
                  </div>
                  <p className="text-sm text-foreground-600 leading-relaxed">{review.text}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Contact Section */}
        <section className="max-w-4xl mx-auto px-4 md:px-6 py-14">
          <div className="text-center mb-10">
            <h2 className="font-heading font-bold text-2xl text-foreground-950 mb-4">联系我们</h2>
            <div className="w-12 h-1 rounded-full bg-primary-500 mx-auto mb-6"></div>
            <p className="text-sm text-foreground-600 max-w-2xl mx-auto">
              如果您有任何问题、建议或合作意向，欢迎通过以下方式与我们联系。
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-10">
            <div className="p-6 rounded-lg bg-background-50 border border-background-200/70 text-center">
              <div className="w-12 h-12 mx-auto mb-4 flex items-center justify-center rounded-full bg-primary-100">
                <i className="ri-mail-line text-primary-500 text-xl"></i>
              </div>
              <h3 className="font-heading font-semibold text-base text-foreground-950 mb-2">电子邮箱</h3>
              <p className="text-sm text-foreground-600">support@mousehole.cn</p>
            </div>
            <div className="p-6 rounded-lg bg-background-50 border border-background-200/70 text-center">
              <div className="w-12 h-12 mx-auto mb-4 flex items-center justify-center rounded-full bg-accent-100">
                <i className="ri-wechat-line text-accent-500 text-xl"></i>
              </div>
              <h3 className="font-heading font-semibold text-base text-foreground-950 mb-2">微信公众号</h3>
              <p className="text-sm text-foreground-600">皮皮漫画</p>
            </div>
            <div className="p-6 rounded-lg bg-background-50 border border-background-200/70 text-center">
              <div className="w-12 h-12 mx-auto mb-4 flex items-center justify-center rounded-full bg-secondary-100">
                <i className="ri-question-answer-line text-secondary-500 text-xl"></i>
              </div>
              <h3 className="font-heading font-semibold text-base text-foreground-950 mb-2">在线客服</h3>
              <p className="text-sm text-foreground-600">工作日 9:00-18:00</p>
            </div>
          </div>

          {/* FAQ */}
          <div>
            <h3 className="font-heading font-bold text-xl text-foreground-950 mb-6 text-center">常见问题</h3>
            <div className="space-y-3">
              <div className="p-4 rounded-lg bg-background-50 border border-background-200/70">
                <h4 className="font-medium text-sm text-foreground-950 mb-2">皮皮漫画网的漫画都是免费的吗？</h4>
                <p className="text-sm text-foreground-600">是的，皮皮漫画网所有韩漫资源均免费提供在线阅读，无需任何付费即可畅享全集漫画大全。</p>
              </div>
              <div className="p-4 rounded-lg bg-background-50 border border-background-200/70">
                <h4 className="font-medium text-sm text-foreground-950 mb-2">如何在皮皮漫画网找到想看的漫画？</h4>
                <p className="text-sm text-foreground-600">您可以通过首页的分类导航、搜索功能，或直接浏览漫画分类页面来查找感兴趣的漫画。我们提供按类别、评分、更新时间等多种筛选方式。</p>
              </div>
              <div className="p-4 rounded-lg bg-background-50 border border-background-200/70">
                <h4 className="font-medium text-sm text-foreground-950 mb-2">皮皮漫画网的漫画更新频率如何？</h4>
                <p className="text-sm text-foreground-600">皮皮漫画网每日更新200+话漫画内容，热门韩国漫画资源第一时间同步，确保您不错过任何精彩章节。</p>
              </div>
            </div>
          </div>
        </section>
      </main>
    </>
  );
}